var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import QueryString from './partial/query-string.vue';
import { formatSql } from '@core/plugin/debug/formatting';
var QueryItem = /** @class */ (function (_super) {
    __extends(QueryItem, _super);
    function QueryItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isExpanded = false;
        return _this;
    }
    QueryItem.prototype.onSearchTextChanged = function () {
        this._queryLinesFormattedShort = null;
        this._queryLinesFormattedFull = null;
    };
    QueryItem.prototype.formatSqlAndApplySearchTextHighlight = function (sql) {
        var result = sql;
        var rules = [];
        if (this.searchText.length > 0) {
            rules.push({
                pattern: new RegExp(this.searchText, 'gi'),
                className: 'highlight'
            });
        }
        result = formatSql(result, rules);
        return result;
    };
    Object.defineProperty(QueryItem.prototype, "queryLinesFormattedShort", {
        get: function () {
            if (this._queryLinesFormattedShort == null) {
                this._queryLinesFormattedShort = this.formatSqlAndApplySearchTextHighlight(this.query.formatted_sql).split('\n');
            }
            return this._queryLinesFormattedShort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryItem.prototype, "queryLinesFormattedFull", {
        get: function () {
            if (this._queryLinesFormattedFull == null) {
                this._queryLinesFormattedFull = this.formatSqlAndApplySearchTextHighlight(this.query.formatted_sql_full).split('\n');
            }
            return this._queryLinesFormattedFull;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Object })
    ], QueryItem.prototype, "query", void 0);
    __decorate([
        Prop({ type: String })
    ], QueryItem.prototype, "searchText", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], QueryItem.prototype, "isCurrentRequest", void 0);
    __decorate([
        Watch('searchText')
    ], QueryItem.prototype, "onSearchTextChanged", null);
    QueryItem = __decorate([
        Component({
            components: { QueryString: QueryString }
        })
    ], QueryItem);
    return QueryItem;
}(Vue));
export default QueryItem;
